export default "/_next/static/images/loading-ca9304ec37f085e5bd8658d9a3ee35c3.svg";